import { Button, Email, Phone, Text, Textarea } from "../controls";
import { usePersistStore, useStore } from "../store";
import { ChangeEvent, useEffect, useState } from "react";
import { isEmail } from "validator";
import { SupportMessageService } from "../services";

const LetsGetInTouch: React.FC = () => {
  const { user, token } = usePersistStore((s: any) => s);
  const { setIsLoading, setSuccessMessage } = useStore((s: any) => s);
  const [values, setValues] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  useEffect(() => {
    if (!user || !token) return;

    setValues({
      ...values,
      name: user?.name,
      phone: user?.phone,
      email: user?.email,
    });
  }, []);

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const [validationMessage, setValidationMessage] = useState<string>("");

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!values?.name) return setValidationMessage("Please provide your name.");
    if (!values?.phone)
      return setValidationMessage("Please provide your phone number.");
    if (!values?.email || !isEmail(values?.email))
      return setValidationMessage("Please provide a valid email address.");
    if (!values?.subject)
      return setValidationMessage("Please provide a subject of your message.");
    if (!values?.message)
      return setValidationMessage("Please provide your message.");

    setIsLoading(true);
    let result = await SupportMessageService.create(values);
    if (result?.error) {
      setIsLoading(false);
      setValidationMessage(result?.error);
      return;
    }

    setIsLoading(false);
    cleanUp();
    setSuccessMessage(
      "Your message is submitted successfully! Support team will contact you soon."
    );
  };

  const cleanUp = () => {
    if (!user || !token) {
      setValues({ name: "", phone: "", email: "", subject: "", message: "" });
    } else {
      setValues({
        subject: "",
        message: "",
        name: user?.name,
        phone: user?.phone,
        email: user?.email,
      });
    }
    setSuccessMessage("");
    setValidationMessage("");
  };

  return (
    <div className="container">
      <div className="row py-3">
        <div className="col-12 px-md-0 pb-0">
          <div className="row py-5">
            <div className="col-lg-4 mb-lg-0 mb-4">
              <h2>Let's get in touch</h2>
              <div className="contactMain mt-4">
                {/* <div className="d-flex gap-3 align-items-center mb-3">
                  <div className="holder">
                    <img src="/assets/imgs/white-phone.svg" alt="" />
                  </div>
                  <div>
                    <h5>Phone number</h5>
                    <p>Office timing</p>
                    <p>Mon-Fri 10am-5pm</p>
                  </div>
                </div> */}
                <div className="d-flex gap-3 align-items-center">
                  <div className="holder">
                    <img src="/assets/imgs/mail.svg" alt="" />
                  </div>
                  <div>
                    <h5>Email address</h5>
                    <p>info@boll-e.com</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-1"></div>
            <div className="col-lg-7 disputeModal">
              <div className="row">
                <div className="col-md-6">
                  <Text
                    label="Your name"
                    placeholder="Enter your name"
                    name="name"
                    value={values?.name}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-6">
                  <Email
                    name="email"
                    value={values?.email}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-6">
                  <Phone
                    label="Phone number"
                    showIcon={false}
                    name="phone"
                    value={values?.phone}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-6">
                  <Text
                    label="Subject"
                    placeholder="Subject"
                    name="subject"
                    value={values?.subject}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-12">
                  <Textarea
                    label="Write to us"
                    placeholder="Your message..."
                    name="message"
                    rows={3}
                    value={values?.message}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <Button
                title="Send"
                className="mt-4 letsGetInTouch__sendBtn"
                onClick={handleSubmit}
              />
              {validationMessage && (
                <div className="validation-message">{validationMessage}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LetsGetInTouch;
